import axios from 'axios';
import {AxiosAuthRefreshRequestConfig} from 'axios-auth-refresh';

const AITUTOR_BASE_URL =
  process.env.REACT_APP_AITUTOR_BASE_URL ||
  'https://api.c5.letrus.com.br/aitutor';

// declares the axios instance to be used for AI Tutor communication
const aiTutorAPIClient = axios.create({
  timeout: 360 * 1000,
  baseURL: AITUTOR_BASE_URL,
});

// returns a configured axios instance,  bearing the correct auth token
function aiTutorAPI(url: string, axiosParams?: AxiosAuthRefreshRequestConfig) {
  return aiTutorAPIClient({
    url,
    withCredentials: true,
    headers: {...axiosParams?.headers},
    ...axiosParams,
  });
}

export default aiTutorAPI;
